import { render, staticRenderFns } from "./export-vin.vue?vue&type=template&id=2cf63ab0&scoped=true"
import script from "./export-vin.vue?vue&type=script&lang=ts"
export * from "./export-vin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf63ab0",
  null
  
)

export default component.exports